const permissions = {
  // USER MANAGEMENT PERMISSIONS
  VIEW_USER_MANAGEMENT: "USER MANAGEMENT.VIEW_USERS", //*added
  VIEW_ROLES_PERMISSIONS: "USER MANAGEMENT.VIEW_ROLES_PERMISSIONS", //*added
  INVITE_USER: "USER MANAGEMENT.INVITE_USER", //*added
  UPDATE_USER: "USER MANAGEMENT.UPDATE_USER", //*added
  DEACTIVATE_USER: "USER MANAGEMENT.DEACTIVATE_USER", //*added
  DELETE_USER: "USER MANAGEMENT.DELETE_USER", //*added
  CREATE_ROLES: "USER MANAGEMENT.CREATE_ROLES", //*added
  ASSIGN_PERMISSIONS_TO_ROLES: "USER MANAGEMENT.ASSIGN_PERMISSIONS_TO_ROLES", //*added

  // CUSTOMER MANAGEMENT PERMISSIONS
  VIEW_CUSTOMER_MANAGEMENT: "CUSTOMER MANAGEMENT.VIEW_GROUPS", //*added

  // METRIC BLUEPRINT MANAGEMENT
  VIEW_METRIC_BLUEPRINT_MANAGEMENT:
    "METRIC BLUEPRINT MANAGEMENT.VIEW_BLUEPRINT", //*added
  BLUEPRINT_BUCKET_MAINTENANCE:
    "METRIC BLUEPRINT MANAGEMENT.BUCKET_MAINTENANCE", //*added
  BLUEPRINT_METRIC_MAINTENANCE:
    "METRIC BLUEPRINT MANAGEMENT.METRIC_MAINTENANCE", //*added
  BLUEPRINT_ASSIGN_REMOVE_METRIC:
    "METRIC BLUEPRINT MANAGEMENT.ASSIGN_REMOVE_METRIC", //*added
  BLUEPRINT_UPDATE_DATATYPE: "METRIC BLUEPRINT MANAGEMENT.UPDATE_DATATYPE", //*added
  BLUEPRINT_UPDATE_BENCHMARK: "METRIC BLUEPRINT MANAGEMENT.UPDATE_BENCHMARK", //*added

  // HUDDLE PERMISSIONS
  VIEW_HUDDLE: "HUDDLE.VIEW_HUDDLE", //*added
  EDIT_YESTERDAY_HOURS: "HUDDLE.EDIT_YESTERDAY_HOURS", //*added

  // PRONTO AI
  VIEW_PRONTO_AI: "PRONTO AI.VIEW_PRONTO_AI", //*added

  // OPPORTUNITY DASHBOARD PERMISSIONS
  VIEW_OPPORTUNITY_DASHBOARD: "OPPORTUNITY DASHBOARD.VIEW_OPPORTUNITIES", //*added
  UPDATE_OPPORTUNITY_STATUS: "OPPORTUNITY DASHBOARD.UPDATE_OP_STATUS", //*added
  UPDATE_OPPORTUNITY_STATUS_AFTER_EXPIRY:
    "OPPORTUNITY DASHBOARD.UPDATE_OP_STATUS_AFTER_EXPIRY", //*added
  DELETE_OPPORTUNITY: "OPPORTUNITY DASHBOARD.DELETE_OPPORTUNITY", //*added
  UPDATE_GOALS: "OPPORTUNITY DASHBOARD.UPDATE_MONTH_GOALS", //*added

  // GOALS PERMISSIONS
  VIEW_GOALS: "GOALS.VIEW_GOALS", //*added
  UPDATE_MONTH_GOALS: "GOALS.UPDATE_MONTH_GOALS", //*added
  UPDATE_YEAR_GOALS: "GOALS.UPDATE_YEAR_GOALS", //*added

  // METRICS PERMISSIONS
  VIEW_METRICS: "METRICS.VIEW_METRICS", //*added
  METRICS_CREATE_OPPORTUNITY: "METRICS.CREATE_OPPORTUNITY", //*added

  // PROVIDERS PERMISSIONS
  VIEW_PROVIDERS: "PROVIDERS.VIEW_PROVIDERS", //*added

  // DOCTOR COMPENSATION PERMISSIONS
  VIEW_DOCTOR_COMPENSATION: "DOCTOR COMPENSATION.VIEW_CONTRACT", //*added
  CREATE_CONTRACT: "DOCTOR COMPENSATION.CREATE_CONTRACT", //*added
  EDIT_CONTRACT: "DOCTOR COMPENSATION.EDIT_CONTRACT", //*added
  DELETE_CONTRACT: "DOCTOR COMPENSATION.DELETE_CONTRACT", //*added

  //PNL BUDGET AND REPORT PERMISSIONS
  VIEW_PNL_BUDGET: "P&L BUDGET.VIEW_PNL_BUDGET", //*added
  ADD_PNL_BUDGET: "P&L BUDGET.ADD_PNL_BUDGET",
  VIEW_PNL_REPORT: "P&L BUDGET.VIEW_PNL_REPORT", //*added

  // RESOURCE BUDGET PERMISSIONS
  VIEW_RESOURCE_BUDGET: "RESOURCE BUDGET.VIEW_RESOURCE_BUDGET", //*added
  BEFORE_PUBLISH_OPERATION: "RESOURCE BUDGET.BEFORE_PUBLISH_OPERATION", //*added
  AFTER_PUBLISH_OPERATION: "RESOURCE BUDGET.AFTER_PUBLISH_OPERATION", //*added
  FORECAST_OPERATION: "RESOURCE BUDGET.FORECAST_OPERATION", //*added
  PUBLISH_BUDGET: "RESOURCE BUDGET.PUBLISH_BUDGET", //*added
  VIEW_RESOURCE_FORECAST: "RESOURCE BUDGET.VIEW_RESOURCE_FORECAST", //*added
}

export default permissions
